import { useState, useEffect } from 'react';

export default function PrivacyPage() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0F1A] font-['Inter',sans-serif] text-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0B0F1A]/95 backdrop-blur-sm shadow-lg' : 'bg-[#0B0F1A]'}`}>
        <div className="container mx-auto px-6 py-5 flex items-center justify-between">
          <a href="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/45892e6d71e748886d1432e1d9630a47/a3928045b87b71f5acec5746d9e758fe.png" 
              alt="Vnerd Logo" 
              className="h-14 w-auto"
            />
          </a>
          
          <nav className="hidden lg:flex items-center gap-8">
            <a href="/#home" className="text-sm font-medium text-gray-300 hover:text-white transition-colors cursor-pointer">Home</a>
            <a href="/#services" className="text-sm font-medium text-gray-300 hover:text-white transition-colors cursor-pointer">Services</a>
            <a href="/#works" className="text-sm font-medium text-gray-300 hover:text-white transition-colors cursor-pointer">Works</a>
            <a href="/#about" className="text-sm font-medium text-gray-300 hover:text-white transition-colors cursor-pointer">About</a>
            <a href="/#contact" className="bg-gradient-to-r from-[#7C3AED] to-[#22D3EE] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:shadow-lg hover:shadow-[#7C3AED]/30 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Contact
            </a>
          </nav>

          <button 
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl text-white`}></i>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="fixed inset-0 bg-[#0B0F1A] z-40 lg:hidden pt-24 px-6">
          <nav className="flex flex-col space-y-6">
            <a href="/#home" className="text-lg font-medium text-white hover:text-[#7C3AED]" onClick={() => setMenuOpen(false)}>Home</a>
            <a href="/#services" className="text-lg font-medium text-white hover:text-[#7C3AED]" onClick={() => setMenuOpen(false)}>Services</a>
            <a href="/#works" className="text-lg font-medium text-white hover:text-[#7C3AED]" onClick={() => setMenuOpen(false)}>Works</a>
            <a href="/#about" className="text-lg font-medium text-white hover:text-[#7C3AED]" onClick={() => setMenuOpen(false)}>About</a>
            <a href="/#contact" className="text-lg font-medium text-white hover:text-[#7C3AED]" onClick={() => setMenuOpen(false)}>Contact</a>
          </nav>
        </div>
      )}

      {/* Main Content */}
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">個人情報の取り扱いについて</h1>
            <p className="text-gray-400">最終更新日：2026年2月4日</p>
          </div>

          <div className="space-y-12">
            {/* Section 1 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">1. 個人情報の定義</h2>
              <p className="text-gray-300 leading-relaxed">
                本プライバシーポリシーにおいて「個人情報」とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）を指します。
              </p>
            </section>

            {/* Section 2 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">2. 個人情報の収集方法</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                当社は、以下の方法により個人情報を収集いたします：
              </p>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>お問い合わせフォームからのご入力</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>お電話でのお問い合わせ</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>メールでのやり取り</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>契約書類等の書面</span>
                </li>
              </ul>
            </section>

            {/* Section 3 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">3. 収集する個人情報の項目</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                当社が収集する個人情報は以下の通りです：
              </p>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>氏名</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>会社名・組織名</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>メールアドレス</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>電話番号</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>お問い合わせ内容</span>
                </li>
              </ul>
            </section>

            {/* Section 4 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">4. 個人情報の利用目的</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                当社は、収集した個人情報を以下の目的で利用いたします：
              </p>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>お問い合わせへの回答・対応</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>サービスのご提案・お見積りの作成</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>契約の締結・履行</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>サービスに関する情報提供</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>アフターサポート</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>サービス品質の向上</span>
                </li>
              </ul>
            </section>

            {/* Section 5 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">5. 個人情報の第三者提供</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません：
              </p>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>法令に基づく場合</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-[#22D3EE] text-xl flex-shrink-0 mt-0.5"></i>
                  <span>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</span>
                </li>
              </ul>
            </section>

            {/* Section 6 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">6. 個人情報の安全管理</h2>
              <p className="text-gray-300 leading-relaxed">
                当社は、個人情報の漏洩、滅失または毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業員や委託先に対して、必要かつ適切な監督を行います。
              </p>
            </section>

            {/* Section 7 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">7. 個人情報の開示・訂正・削除</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                お客様は、当社が保有する自己の個人情報について、開示、訂正、追加、削除、利用停止、消去および第三者提供の停止を請求することができます。請求される場合は、以下の連絡先までご連絡ください。
              </p>
              <div className="bg-[#0B0F1A]/50 p-6 rounded-xl border border-white/5">
                <p className="text-gray-300 mb-2">
                  <strong className="text-white">お問い合わせ先：</strong>
                </p>
                <p className="text-gray-300">
                  電話：+84-909-012-811<br />
                  または、<a href="/#contact" className="text-[#22D3EE] hover:underline cursor-pointer">お問い合わせフォーム</a>よりご連絡ください
                </p>
              </div>
            </section>

            {/* Section 8 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">8. Cookie（クッキー）について</h2>
              <p className="text-gray-300 leading-relaxed">
                当社のウェブサイトでは、サービスの利便性向上のためにCookieを使用する場合があります。Cookieとは、ウェブサイトがお客様のコンピュータに送信する小さなテキストファイルです。お客様は、ブラウザの設定によりCookieの受け取りを拒否することができますが、その場合、一部のサービスが利用できなくなる可能性があります。
              </p>
            </section>

            {/* Section 9 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">9. プライバシーポリシーの変更</h2>
              <p className="text-gray-300 leading-relaxed">
                当社は、法令の変更や事業内容の変更等に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            {/* Section 10 */}
            <section className="bg-gradient-to-br from-[#1a1f2e] to-[#0B0F1A] p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold mb-4 text-[#22D3EE]">10. お問い合わせ窓口</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください：
              </p>
              <div className="bg-[#0B0F1A]/50 p-6 rounded-xl border border-white/5">
                <p className="text-gray-300 mb-4">
                  <strong className="text-white">Vnerd（C＆T）</strong>
                </p>
                <p className="text-gray-300 mb-2">
                  所在地：8a/a3 Đ. Thái Văn Lung, Bến Nghé, Quan 1, Ho Chi Minh, Vietnam
                </p>
                <p className="text-gray-300 mb-2">
                  電話：+84-909-012-811
                </p>
                <p className="text-gray-300">
                  お問い合わせフォーム：<a href="/#contact" className="text-[#22D3EE] hover:underline cursor-pointer">こちら</a>
                </p>
              </div>
            </section>
          </div>

          <div className="mt-12 text-center">
            <a 
              href="/#contact" 
              className="inline-block bg-gradient-to-r from-[#7C3AED] to-[#22D3EE] text-white px-10 py-4 rounded-full font-medium hover:shadow-xl hover:shadow-[#7C3AED]/40 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせページへ戻る
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0B0F1A] border-t border-white/5 py-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-8">
            <div>
              <a href="/" className="inline-block mb-4">
                <img 
                  src="https://static.readdy.ai/image/45892e6d71e748886d1432e1d9630a47/a3928045b87b71f5acec5746d9e758fe.png" 
                  alt="Vnerd Logo" 
                  className="h-14 w-auto"
                />
              </a>
              <p className="text-sm text-gray-500 max-w-xs">
                ベトナム最大級のコスプレイヤー／ライバーネットワーク
              </p>
            </div>

            <nav className="flex flex-wrap gap-6 text-sm">
              <a href="/#home" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</a>
              <a href="/#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Services</a>
              <a href="/#works" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Works</a>
              <a href="/#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About</a>
              <a href="/#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a>
              <a href="/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacy</a>
            </nav>
          </div>

          <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center md:items-end gap-4 text-sm text-gray-500">
            <div className="space-y-2 text-center md:text-left">
              <p>8a/a3 Đ. Thái Văn Lung, Bến Nghé, Quan 1, Ho Chi Minh, Vietnam</p>
              <p>Tel: +84-909-012-811</p>
            </div>
            <div className="flex items-center gap-2">
              <p>&copy; 2024 Vnerd. All Rights Reserved.</p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
